/* @flow */

import * as React from "react";

import { Link } from "react-router";
import { trackStructuredEvent } from "shared/src/utils/TrackingUtil";

type To = {
    pathname: string;
    search: string;
};

type StringFn = () => string; // FIXME(FD)

type Props = {
    from: string;
    to: To | StringFn;
    children: React.ReactNode;
    className?: string;
    onClick?: () => void;
    targetBlank?: boolean;
    absolutePath?: boolean;
    download?: string | undefined | null;
};

class TrackedLink extends React.PureComponent<Props> {
    constructor(props: Props) {
        super(props);
    }

    trackOnClick = (to: To) => {
        if (this.props.onClick) {
            this.props.onClick();
        }
        trackStructuredEvent("app.openLink", { tags: { from: this.props.from, to: to.pathname + to.search } });
    };

    getTo(): {
        pathname: string;
        search: string;
    } {
        if (typeof this.props.to === "function") {
            return { pathname: this.props.to.apply(undefined), search: "" };
        }
        return this.props.to;
    }

    getTrackedLink(href: string, to: To) {
        return (
            <a
                href={href}
                download={this.props.download}
                target={this.props.targetBlank ? "_blank" : undefined}
                onClick={() => this.trackOnClick(to)}
                className={this.props.className}>
                {this.props.children}
            </a>
        );
    }
    render() {
        const to = this.getTo();
        const { pathname: pathname, search: search } = to;
        if (to.pathname?.startsWith("/")) {
            return (
                <Link to={to} onClick={() => this.trackOnClick(to)} className={this.props.className}>
                    {this.props.children}
                </Link>
            );
        } else if (this.props.absolutePath) {
            return this.getTrackedLink("/".concat(pathname, search || ""), to);
        }
        return this.getTrackedLink("".concat(pathname, search || ""), to);
    }
}

export default TrackedLink;
